import { render, staticRenderFns } from "./Importer.vue?vue&type=template&id=a5de0f5e&scoped=true"
import script from "./Importer.vue?vue&type=script&lang=js"
export * from "./Importer.vue?vue&type=script&lang=js"
import style0 from "./Importer.vue?vue&type=style&index=0&id=a5de0f5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5de0f5e",
  null
  
)

export default component.exports